var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    className: "custom-icon-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #02735e;\n        transition: fill 0.3s;\n      }\n\n      .cls-2 {\n        fill: #d9d9d9;\n        transition: fill 0.3s;\n      }\n\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 100,
    cy: 100,
    r: 100
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.99,93.6l-70.84-34.3c-2.98-1.44-6.36-.81-8.8,1.66-2.44,2.47-3.46,6.27-2.67,9.92l6.31,28.85h30.87c1.42,0,2.57,1.34,2.57,3s-1.15,3-2.57,3h-30.87l-6.31,28.85c-.8,3.65.22,7.46,2.67,9.92,2.45,2.47,5.82,3.1,8.8,1.66l70.84-34.29c3.23-1.56,5.23-5.06,5.23-9.14s-2-7.58-5.23-9.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendButton);
export default __webpack_public_path__ + "static/media/SendButton.6290df681941e804b9bfc60533058990.svg";
export { ForwardRef as ReactComponent };